import { ConsumptionSummary } from "@/models/consumption/consumption-summary"
import { OverSpent } from "@/models/consumption/over-spent"
import { IConsumptionGlobalSummaryDTO } from "@/interface"
import { IAverageConsumption } from "@/interface/services"
import { bytesToMegabytes, convertSecondsToMinutes } from "@/mega-ui/helpers/function"
import {ConsumptionSafeguard} from "@/models/consumption/consumption-safeguard";

export class ConsumptionGlobalSummary {

    public consumptionsSummary: ConsumptionSummary | null;
    public overSpent: OverSpent | null;
    public safeguard?: ConsumptionSafeguard | null;

    constructor(base?: Partial<ConsumptionGlobalSummary>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IConsumptionGlobalSummaryDTO): ConsumptionGlobalSummary | null {
        if (!dto || !dto.balances || !dto.cdrUsage || !dto.cdrOverspent) {
            return null;
        }

        return new ConsumptionGlobalSummary({
            consumptionsSummary: ConsumptionSummary.fromDto(dto),
            overSpent: OverSpent.fromDto(dto),
            safeguard: dto.safeguard ? ConsumptionSafeguard.fromDto(dto.safeguard) : null
        });
    }

    public getAverageConsumption(marginAverage = 6): IAverageConsumption {
        return {
            minutes: this.consumptionsSummary?.CALL?.value ?
                +(convertSecondsToMinutes(this.consumptionsSummary?.CALL?.value) / marginAverage).toFixed(2)
                : 0,
            sms: this.consumptionsSummary?.SMS?.value ?
                +(this.consumptionsSummary?.SMS?.value / marginAverage).toFixed(2)
                : 0,
            data: this.consumptionsSummary?.DATA?.value ?
                +(bytesToMegabytes(this.consumptionsSummary?.DATA?.value) / marginAverage).toFixed(2)
                : 0
        }
    }

}
